import React from 'react';
import CreateLcaProductInformation from './CreateProductInformation';

export default function LcaCreateProduct() {
  return <CreateLcaProductInformation />;
}
